import { Radio, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import ThemeContext from "../../../../../../context";

// ----------------------------------------------------------------------

type Props = {
	onClick: () => void;
	isChecked?: boolean;
	title: string;
};

export const RadioItem = ({ onClick, isChecked, title }: Props) => {
	const { theme } = useContext(ThemeContext);

	const { translate } = useLocales();

	return (
		<Stack direction={"row"} alignItems={"center"} gap={0.5}>
			<Radio
				checked={isChecked}
				size='small'
				sx={{
					p: 0.5,
					"&, &.Mui-checked": {
						color: isChecked ? theme?.colors.primary : theme?.colors.secondaryText
					}
				}}
				onClick={onClick}
			/>
			<Typography variant='body2' color={theme?.colors.primaryText}>
				{translate(title)}
			</Typography>
		</Stack>
	);
};

export default RadioItem;
